import { Trans } from '@lingui/macro'
import React, { SVGAttributes } from 'react'

export const IconBook = (props: SVGAttributes<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 33 28.5" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>
      <Trans>manuál</Trans>
    </title>
    <path
      fill="#F59100"
      className="st0"
      d="M24.8,18.3v6.5c0,0,0,0.1-0.1,0.2c0,0-0.2,0.1-0.3,0c-4.3-1.2-7.7-0.2-9.8,0.6V10.8c0.1,0,0.2-0.1,0.3-0.1
	c-0.2-0.7-0.3-1.5-0.3-2.3c-0.4,0.2-0.8,0.3-1.1,0.5c-1-0.5-3-1.3-5.8-1.3c-1.9,0-3.9,0.3-6.1,1.1C0.7,9,0,10,0,11.1v13.7
	c0,0.8,0.3,1.5,0.9,2c0.7,0.5,1.5,0.7,2.3,0.4c5.5-1.5,9.5,1.1,9.6,1.2c0.2,0.1,0.4,0.2,0.6,0.2c0.1,0,0.4,0,0.6-0.2
	c0.2-0.1,4.1-2.7,9.7-1.2c0.8,0.2,1.6,0,2.2-0.4c0.7-0.5,1-1.2,1-2V18C26.3,18.2,25.5,18.3,24.8,18.3z M12.4,25.5
	c-1.3-0.5-3.3-1.1-5.7-1.1c-1.2,0-2.6,0.1-4,0.6c-0.1,0-0.3,0-0.3,0c-0.1-0.1-0.1-0.2-0.1-0.2V11.1c0-0.1,0-0.2,0.1-0.3
	c1.9-0.7,3.8-1,5.3-1c2.2,0,3.8,0.6,4.7,1V25.5z"
    />
    <path
      fill="#F59100"
      className="st0"
      d="M25,0c-4.4,0-8,3.6-8,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C33,3.6,29.4,0,25,0z M25,4c0.5,0,1,0.5,1,1
	c0,0.6-0.5,1-1,1c-0.6,0-1-0.4-1-1C24,4.5,24.4,4,25,4z M26.2,12h-2.5c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8h0.8v-2h-0.8
	c-0.4,0-0.8-0.3-0.8-0.8C23,7.3,23.3,7,23.8,7h1.5C25.7,7,26,7.3,26,7.8v2.8h0.2c0.4,0,0.8,0.3,0.8,0.8C27,11.7,26.7,12,26.2,12z"
    />
  </svg>
)
